export default __webpack_public_path__ + "static/assets/f272d1980ab7e1be05626e8d13026073.png";